import { ajax } from '@/util/ajax'

const BASE_URL = '/gateway/platform-lmsapi/lead'

const OpenApi = {
  pandaLead (data, success, failure) {
    return ajax.post(
      BASE_URL + '/manually-create',
      data,
      success,
      failure,
      { showLoading: true }
    )
  },
  listChannel (input, success, failure) {
    return ajax.get(
        `${BASE_URL}/channel/list`,
        input,
        success,
        failure
    )
  }
}

export { OpenApi }
